import { SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const StyledDecisionContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${SYS_SPACE_FIXED_300};

	.overflow-hidden {
		overflow: hidden;
	}
`;

export const StyledAutomaticChangeSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
	padding: ${SYS_SPACE_FIXED_300};
`;

export const StyledStickyHeader = styled.div`
	position: sticky;
	top: 0;
	z-index: 10;
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	gap: ${SYS_SPACE_FIXED_300};
	background-color: white;
	padding: ${SYS_SPACE_FIXED_150} 0;
`;

export const StyledHeaderContent = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
`;

export const StyledChildrenContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
`;
